/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewrefresh2Inputs */

const en_letterpreviewrefresh2 = /** @type {(inputs: Letterpreviewrefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate`)
};

const pt_letterpreviewrefresh2 = /** @type {(inputs: Letterpreviewrefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar a gerar`)
};

/**
* | output |
* | --- |
* | "Regenerate" |
*
* @param {Letterpreviewrefresh2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewrefresh2 = /** @type {((inputs?: Letterpreviewrefresh2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewrefresh2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewrefresh2(inputs)
	return pt_letterpreviewrefresh2(inputs)
});
export { letterpreviewrefresh2 as "letterPreviewRefresh" }